const transformTimeNumbersToString = (num: number): string => (num < 10 ? `0${num}` : `${num}`);

export const getHourList = () => [...Array(24).keys()].map((item) => transformTimeNumbersToString(item));
export const getMinutesList = () => [...Array(60).keys()].map((item) => transformTimeNumbersToString(item));
